const Condition = require( './Condition' );

const ArmorBrokenCondition = function( instigator, owner, battleState, potency ) {
	const condition = new Condition( instigator, owner, battleState, potency );
	condition.handle = 'armor_broken';

	return condition;
};
module.exports = ArmorBrokenCondition
